import Vue from "vue";
import { whenConsented } from "../../helper/whenConsented";
import { debounce } from "../../../ceres/helper/debounce";

function _runFn(callback, el, callbackSelectors, debounceTimeout = null) {
	callbackSelectors.forEach(callbackSelector => {
		if (el.querySelectorAll(callbackSelector).length) {

			if (debounceTimeout !== null) {
				debounce(callback({ el, callbackSelector }), debounceTimeout);
			} else {
				callback({ el, callbackSelector });
			}
		}
	});
}

function registerObserverOnElement(el, callbackSelectors, callback, runBeforehand, debounceTimeout = null) {
	if (runBeforehand) {
		_runFn(callback, el, callbackSelectors, debounceTimeout);
	}
	const observer = new MutationObserver(mutations => {
		mutations.forEach(__ => {
			_runFn(callback, el, callbackSelectors, debounceTimeout);
		});
	});

	window.observerCount++;
	const observerId = observer.observe(el, {
		attributes: true,
		childList: true,
		subtree: true
	});

	el.registeredObservers.push({ observerId, observer });
}

Vue.directive("mutation-observer", {
	bind(el, binding) {
		if (typeof el.registeredObservers === "undefined") {
			el.registeredObservers = [];
		}
		if (typeof binding.value.id !== "undefined") {
			if (typeof window.mutationObservers !== "undefined" && Object.keys(window.mutationObservers).length) {
				Object.keys(window.mutationObservers).forEach(componentName => {
					if (componentName === binding.value.id) {
						window.mutationObservers[componentName].forEach(observeItem => {
							const { callbackSelectors, callback, runBeforehand, useWhenConsented, debounceTimeout } = observeItem;

							if (useWhenConsented) {
								whenConsented(
									"",
									() => {
										registerObserverOnElement(el, callbackSelectors, callback, runBeforehand, debounceTimeout);
									},
									() => {}
								);
							} else {
								registerObserverOnElement(el, callbackSelectors, callback, runBeforehand, debounceTimeout);
							}
						});
					}
				});
			}
		} else if (typeof binding.value.fn === "function" && typeof binding.value.selectors !== "undefined") {
			if (typeof binding.value.useWhenConsented !== "undefined" && binding.value.useWhenConsented) {
				whenConsented(
					"",
					() => {
						registerObserverOnElement(el, binding.value.selectors, binding.value.fn, binding.value.runBeforehand ?? false, binding.value.debounceTimeout ?? null);
					},
					() => {}
				);
			} else {
				registerObserverOnElement(el, binding.value.selectors, binding.value.fn, binding.value.runBeforehand ?? false, binding.value.debounceTimeout ?? null);
			}
		}
	},
	unbind(el) {
		if (el.registeredObservers.length) {
			el.registeredObservers.forEach(({ observer }) => {
				window.observerCount--;
				observer.disconnect();
			});
		}
	}
});
